module.exports = __webpack_public_path__ + "img/07_04.28a8d081.jpg";